import { render, staticRenderFns } from "./TestPush.vue?vue&type=template&id=539b7f36&"
import script from "./TestPush.vue?vue&type=script&lang=js&"
export * from "./TestPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestPush.vue"
export default component.exports